import { STATUS_TYPES } from '../../constants';

export default {
  status: STATUS_TYPES.UNLOAD_STATE,
  data: null,
  error: null,
};
